export default {"src":"/_next/static/media/Vector-quarter-circle2.2b643b48.svg","height":69,"width":58,"blurWidth":0,"blurHeight":0};